var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('img',{attrs:{"src":require("@/assets/img/ico_question.svg"),"alt":""}}),_c('div',{staticClass:"top"},[_c('span',[_vm._t("default")],2),_c('i')])])
}
var staticRenderFns = []

export { render, staticRenderFns }